module.exports = {
  message: {
    "Export": "Export",
    "Import": "Import",
    "Account": 'Account management',
    "User List": "User List",
    "Role List": "Role List",
    "Group List": "Group List",
    "Group Detail": "Group Detail",
    "Description": "Description",
    "GroupName": "Group Name",
    "userName": "User name",
    "Status": "Status",
    "Search": "Search",
    "datagridresult": " results in total",
    "RoleName": "Role Name",
    "createdTime": "Created date",
    "Add": "Add",
    "Delete": "Delete",
    "password": "Password",
    "Tel": "Telephone",
    "email": "Email",
    "Role": "Role",
    "Active": "Active",
    "Inactive": "Inactive",
    "Save": "Save",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Warning": "Warning",
    "RoleType": "Role type",
    "Super Admin": "Super Admin",
    "Platform": "Platform",
    "RoleGroup": "Role Group",
    "FunctionSelection": "Function & Feature",
    "All": "--- All ---",
    "selectDefault": "--- Default ---",
    "PleaseSelect": "--- Please Select ---",
    "title": "Title",
    "LogOut": "Logout",
    "Name": "Name",
    "English": "English",
    "Simplified Chinese": "Simplified Chinese",
    "Traditional Chinese": "Traditional Chinese",
    "en_US": "English",
    "zh_CN": "Simplified Chinese",
    "zh_HK": "Chinese",
    "HomePage": "Home page",
    "User Detail": "User Detail",
    "Role Detail": "Role Detail",
    "Publish": "Publish",
    "Draft": "Draft",
    "Published": "Published",
    "Preview": "Preview",
    "Edit": "Edit",
    "Landing Page Management": "Landing Page Management",
    "Account Management": "Account Management",
    "deleteContent": "Are you sure to delete the selected content?",
    "required": "This field is required",
    "Period": "Period",
    "fillRequired": "Please fill in the required information",
    "leaveTip": "Do you want to leave without saving changes?",
    "welcome": "Welcome to Zeelo CMS!",
    "Login": "Login",
    "forgetPassword": "Forgot password?",
    "Type": "Type",
    "Mobile": "Mobile",
    "Project": "Project",
    "Language": "Language",
    "synonyms": "Synonyms",
    "hotSearch": "Hot Search",
    "Group": "Group",
    "Project name": "Project name",
    "Api Key": "Api Key",
    "Remarks": "Remarks",
    "Dimension Error!": "Dimension Error!",
    "Size error!": "Size error!",
    "Default poi pin image": "Default poi pin image",
    "Project time zone": "Project time zone",
    "Zone did change logging timeout": "Zone did change logging timeout",
    "Zone logging timeout": "Zone logging timeout",
    "Push message timeout": "Push message timeout",
    "Number of recent search": "Number of recent search",
    "Map num recent search": "Map num recent search",
    "Add language": "Add language",
    "Lang code": "Lang code",
    "Default": "Default",
    "Default Language": "Default Language",
    "Languages": "Languages",
    "Number of search result paths in path findings": "Number of search result paths in path findings",
    "Map num search paths": "Map num search paths",
    "Aos change floor filters": "Aos change floor filters",
    "Ios change floor filters": "Ios change floor filters",
    "Map default zoom": "Map default zoom",
    "Number of pixels represent 1 metre in maps": "Number of pixels represent 1 metre in maps",
    "Map scale": "Map scale",
    "Map pace tip": "Walking speed in terms of metre per second. Average walking speed is about 1.4 m/s",
    "Map pace": "Map pace",
    "Map direction": "Map direction",
    "Ble uuid": "Ble uuid",
    "Image": "Image",
    "visibleOnMap": "Visible On Map",
    "searchable": "Search able",
    "Tag": "Tag",
    "externalId": "ExternalId",
    "Project List": "Project List",
    "POI": "POI",
    "POI List": "POI List",
    "Category": "Category",
    "Category List": "POI Category List",
    "Tag Group List": "Tag Group List",
    "Tag List": "Tag List",
    "POI Tag List": "POI Tag List",
    "User": "User",
    "Log": "Log",
    "Log List": "Activity Log",
    "Category Detail": "Category Detail",
    "Log Detail": "Log Detail",
    "POI Detail": "POI Detail",
    "POI Tag Detail": "POI Tag Detail",
    "Tag Detail": "Tag Detail",
    "Tag Group Detail": "Tag Group Detail",
    "Project Detail": "Project Detail",
    "Parent": "Parent",
    "Ordering": "Ordering",
    "UUID": "UUID",
    "UUID List": "UUID List",
    "UUID Detail": "UUID Detail",
    "Beacon List": "Beacon List",
    "Device Name": "Device Name",
    "Area": "Area",
    "Battery Level": "Battery Level",
    "Serial No": "Serial No.",
    "Major": "Major",
    "Wayfinding": "Wayfinding",
    "Proximity": "Proximity",
    "Lift Inside": "Lift Inside",
    "Health": "Health",
    "Zone": "Zone",
    "Last Update": "Last Update",
    "Healthy": "Healthy",
    "Unhealthy": "Unhealthy",
    "Unknown": "Unknown",
    "Beacon Management": "Beacon Management",
    "Alert Template": "Alert Template",
    "Floor": "Floor",
    "Map": "Map",
    "Base Map": "Base Map",
    "Map Editor": "Map Editor",
    "Marker": "Marker",
    "Marker List": "Marker List",
    "Setting": "Setting",
    "Adaptor": "Adaptor",
    "MS Account": "MS Account",
    "Home": "Home",
    "Location Analytics": "Location Analytics",
    "Base Map Detail": "Base Map Detail",
    "Marker Detail": "Marker Detail",
    "Attribute Config": "Attribute Config",
    "Attribute Config List": "Attribute Config List",
    "Attribute Config Detail": "Attribute Config Detail",
    "Message": "Message",
    "Message List": "Message List",
    "Message Detail": "Message Detail",
    "Master Data": "Master Data",
    "Content Publish": "Content Publish",
    "POI Management": "POI Management",
    "POI Category List": "POI Category List",
    "Mapping Service": "Mapping Service",
    "Messaging": "Messaging",
    "Geofencing Zone List": "Geofencing Zone List",
    "Data Dashboard": "Data Dashboard",
    "User Management": "User Management",
    "Coordinate System": "Coordinate System(CS)",
    "CS Venue": "CS Venue",
    "Venue": "Venue",
    "Geo X Offset": "Geo X Offset",
    "Geo Y Offset": "Geo Y Offset",
    "Tools Project Id": "Tools Project Id",
    "Indoor Atlas Floor Plan": "Indoor Atlas Floor Plan",
    "Coordinate Api Key": "CS Api Key",
    "System": "System",
    "Other Services": "Other Services",
    "Activity Log": "Activity Log",
    "Coordinate Secret": "CS Secret",
    "ARWiz": "ARWiz",
    "passwordFormat": "Password must be 6-16 characters in length and include letter(s) and number(s).",
    "projectListTip": "You may view your list of projects here,<br> and update project detailed configurations. ",
    "markerListTip": "A marker is an object that marks a locality. These <br> localities on the map provide viewing status only <br> and not necessary to provide search to user.<br><br>For example, escalator, elevator, staircase, <br> moving walkway.<br><br>After adding markers here, you may proceed to Map <br> Editor to map the marker on map.",
    "tagGroupListTip": "If you have numerous tags, you may consider <br> to group them into tag group lists for easy <br> management,  ie. you may group male toilets <br> and female toilets to “Facilities”.",
    "tagListTip": "This is to add tags for your map. After <br> adding tag here, you may add the tag on <br> the map in Mapping Service later. ",
    "categoryListTip": "You may add categories below for grouping <br> of POIs. ie. toilets, restaurants, etc.",
    "attributeConfigListTip": "You may add tags for wayfinding route <br> searching, ie. some routes are staff only, or <br> some places may only can be accessed at <br> 18 years old above. You may select these <br> attributes at Map Editor later.",
    "baseMapTip": "Base map layers are a kind of map layers <br> that provide a framework onto which you <br> display the map information. The map <br> added here will be displayed on app. All <br> maps should be in the same dimension, ie. <br> with the same width and height in pixels.",
    "mapEditorListTip": "You may add path and POI here. Click on  <br><img src='./assets/icon_path_off.png' /> to create path, <br><img src='./assets/icon_poi_off.png' /> to create POI, <br> <img src='./assets/icon_marker_off.png' /> to create marker. To edit existing POI, please click <br> <img src='./assets/icon_select_off.png' /> to change to view mode and click on the <br> POI for edit. <br><img src='./assets/icon_device_off.png' /> to display/hidden device <br> <br> To enter POI detailed information, please <br> go to POI List. ",
    "poiListTip": "You may add extra business information of <br> the POI you just created on Map Editor here. ",
    "beaconZoneListTip": "You may view your geofencing zone here, <br> which is provided by the location service <br> provider, ie. IndoorAtlas. You may tailor <br> messaging on the next page",
    "uuidListTip": "You may add your beacon UUIDs here. You  may <br> find the UUID from your “beacon management system”.",
    "beaconListTip": "You may view the list of Beacon installed <br> and check their battery level.",
    "alertTemplateListTip": "You may tailormade the alert colour of Beacon <br> installed for easy review in Beacon list. ",
    "demoReportTip": "You may view the data collected from your project here.",
    "userListTip": "You can view and manage the user accounts <br> opened for your project, ie. create accounts <br> or deactivate accounts.     ",
    "Confex Management": "Confex Management",
    "Event": "Event",
    "Event Detail": "Event Detail",
    "Event Code": "Event Code",
    "Title": "Title",
    "Event Type": "Event Type",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "Create Time": "Create Time",
    "Highlights": "Highlights",
    "Rearrange Order": "Rearrange Order",
    "Event Group": "Event Group",
    "Event Group Detail": "Event Group Detail",
    "Event Type List": "Event Type List",
    "Event Type Detail": "Event Type Detail",
    "Venue List": "Venue List",
    "Venue Detail": "Venue Detail",
    "Minor": "Minor",
    "Please enter the file name": "Please enter the file name",
    "Form Builder": "Form Builder",
    "Hot Tags": "Hot Tags",
    "Hot Events": "Hot Events",
    "deleteMapTip": "<b>Confirm Permanent Deletion</b><br><br>Are you sure you want to delete the selected items permanently? Once deleted permanently, they cannot be recovered or restored on Map Editor.",
    "Message Rule": "Message Rule",
    "Path": "Path",
    "Daily Trend": "Daily Trend",
    "Daily Average Dashboard": "Daily Average Dashboard",
    "Heat Map": "Heat Map",
    "Raw Data": "Raw Data",
    "Overview": "Overview",
    "Heat Map and Dwell Time": "Heat Map and Dwell Time",
    "Path Dwell": "Path Dwell",
    "Asset Service": "Asset Service",
    "Asset Zone": "Asset Zone",
    "Asset List": "Asset List",
    "Asset Detail": "Asset Detail",
    "Preset Beacon List": "Preset Beacon List",
    "Planning Beacon List": "Planning Beacon List",
    "beaconPresetListTip": "test",
    "beacon Preset List": "beacon Preset List",
    "beacon Planning List": "beacon Planning List",
    "Deployment Beacon List": "Deployment Beacon List",
    "TX Power(dBm)": "TX Power(dBm)",
    "interval(ms)": "interval(ms)",
    "External ID": "External ID",
    "Remark": "Remark",
    "Installed": "Installed",
    "Planned": "Planned",
    "Planning ID": "Planning ID",
    "Project Name": "Project Name",
    "Function Type": "Function Type",
    "Floor Name": "Floor Name",
    "X": "X",
    "Y": "Y",
    "Disable": "Disable",
    "Enable": "Enable",
    "Update": "Update",
    "Packge name": "Packge name",
    "Key store": "Key store",
    "Bundle ID": "Bundle ID",
    "Add New": "Add New",
    "Geofence Editor": "Geofence Editor",
    "IMDF": "IMDF",
    "SubprojectName": "SubprojectName",
    "prompt Message Maintenance List": "prompt Message Maintenance List",
    "Prompt Message Maintenance": "Prompt Message Maintenance",
    "Deselect": "Deselect",
    "Building Area Editor": "Building Area Editor"
  }
}